import { useSearchParams } from 'react-router-dom';

export const useTradeIDQueryParams = () => {
  const [searchParams] = useSearchParams();

  const getQueryParam = (param: string) => {
    return searchParams.get(param);
  };

  return {
    companyId: getQueryParam('company_id'),
    companyName: getQueryParam('company_name'),
    dealId: getQueryParam('deal_id'),
    inspectionId: getQueryParam('inspection_id'),
    loadName: getQueryParam('load_name'),
    purchaseOrderSlug: getQueryParam('purchase_order_slug'),
    salesOrderSlug: getQueryParam('sales_order_slug'),
    shipmentName: getQueryParam('shipment_name'),
  };
};
